import React from "react";
import { APP_VERSION } from "../url_config";

const VersionFooter = () => {
  return (
    <div
      style={{
        padding: "10px 16px",
        textAlign: "center",
        color: "#64748b",
        fontSize: 12,
        borderTop: "1px solid rgba(148, 163, 184, 0.25)",
        background: "rgba(255,255,255,0.92)",
      }}
    >
      Version de l'application : {APP_VERSION}
    </div>
  );
};

export default VersionFooter;